import Component from "../component";
import Urls from "../../configuration/urls.config";
import {loadScript} from "../../utils/load_script";
import {replace} from "../../utils/utils";
import {getLocale, getLocaleLang} from "../../helpers/locale";
import { getConfig } from "configuration/config";

export interface IMapComponent {
    woosmapPublicKey: string;
    mapOptions: woosmap.map.MapOptions;
    indoorRendererOptions: woosmap.map.IndoorRendererOptions;
    indoorWidgetOptions:woosmap.map.IndoorWidgetOptions;
    query?: string;
    padding?: woosmap.map.Padding;
    zoom?: number;
    filter?: string
    libraries: string;
}

export enum MapComponentEvents {
    MAP_READY = "map_ready",
    MAP_IDLE = "idle",
    INDOOR_VENUE_LOADED = 'indoor_venue_loaded',
    INDOOR_WIDGET_ANALYTICS = 'indoor_widget_analytics',
    INDOOR_POI_ON_MAP_CLICK = 'indoor_feature_selected',
    INDOOR_HIGHLIGHT_STEP = 'indoor_highlight_step',
    INDOOR_STOP_NAVIGATION = 'indoor_stop_navigation'
}

export default class MapComponent extends Component<IMapComponent> {
    public map!: woosmap.map.Map;
    public indoorMap!: woosmap.map.IndoorWidget;

    init(): void {
        this.$element = document.createElement("div");
        this.$element.id = 'map';
        this.$target.appendChild(this.$element);
    }
    render(): void {
        if (this.state && this.$element) {
            loadScript({
                url: Urls.mapJS,
                params: {key: this.state.woosmapPublicKey, libraries: this.state.libraries, language: getLocaleLang().toLowerCase()},
                override: true,
                callback: () => {this.initMapView()}
            })
                .then(() => {
                    // this.initMapView();
                    console.log('Scripts loaded...');
                })
                .catch((error) => {
                    console.error(
                        replace(getLocale().errors.loadingLibrary, {'library': "Woosmap Map JS SDK script"}),
                        error
                    );
                });
        }
    }

    initMapView(): void {
        this.map = new woosmap.map.Map(
            'map',
            Object.assign({}, this.state.mapOptions)
        )
        
        this.emit(MapComponentEvents.MAP_READY);
        this.map.addListener(MapComponentEvents.MAP_IDLE, ()=> {
            this.emit(MapComponentEvents.MAP_IDLE);
        })
        this.map.addListener('rightclick', (e) =>{
            console.log(e);
        })
    }
    initIndoorView(): void {
        const widgetOptions = this.state.query && this.state.query !== `thematic:=${getConfig().map.indoorRendererOptions.theme}` ? { ...this.state.indoorWidgetOptions, baseFilter: this.state.query } : this.state.indoorWidgetOptions;
        const rendererOptions = this.state.query && this.state.query !== `thematic:=${getConfig().map.indoorRendererOptions.theme}` ? { ...this.state.indoorRendererOptions, baseFilter: this.state.query } : this.state.indoorRendererOptions;
        this.indoorMap = new woosmap.map.IndoorWidget(widgetOptions, rendererOptions);
        this.indoorMap.setMap(this.map);
        this.indoorMap.addListener(
            MapComponentEvents.INDOOR_VENUE_LOADED,
            (venue: woosmap.map.Venue) => {
                this.emit(MapComponentEvents.INDOOR_VENUE_LOADED, venue);
            }
        );
        this.indoorMap.addListener(
            MapComponentEvents.INDOOR_WIDGET_ANALYTICS,
            (event:any) => {
                this.emit(MapComponentEvents.INDOOR_WIDGET_ANALYTICS, event);
            }
        );
        this.indoorMap.addListener(
            MapComponentEvents.INDOOR_POI_ON_MAP_CLICK,
            (event:any) => {
                this.emit(MapComponentEvents.INDOOR_POI_ON_MAP_CLICK, event);
            }
        );
        this.indoorMap.addListener(
            MapComponentEvents.INDOOR_HIGHLIGHT_STEP,
            (event:any) => {
                this.emit(MapComponentEvents.INDOOR_HIGHLIGHT_STEP, event);
            }
        );
        this.indoorMap.addListener(
            MapComponentEvents.INDOOR_STOP_NAVIGATION,
            (event:any) => {
                this.emit(MapComponentEvents.INDOOR_STOP_NAVIGATION, event);
            }
        );
    }
    setFilter(filter:string):void{
        const filterToApply = filter !== undefined ? (`thematic:=${filter} OR ${filter}:=true`) : ``;
        if(filter !== "sdm_default"){
            this.indoorMap.getRenderer().setBaseFilter(filterToApply);
            this.indoorMap.setBaseFilter(filterToApply);
        }
    }
    setOrigin(data:any):void{
        this.indoorMap.setUserLocation(data.lat,data.lng, data.level || 0, 0, true);
    }
    setTheme(theme:string):void{
        const themeToApply = theme !== undefined ? theme : 'sdm_default';
        this.indoorMap.setTheme(themeToApply);
    }
    setBounds(bounds: woosmap.map.LatLngBounds){
        let padding = {
            top: 0, left: 150, right: 150, bottom: 0
        };
        if(this.$element.clientWidth > 768){
            padding = {
                top: 350, left: 350, right: 350, bottom: 350
            };
        }
        this.map.fitBounds(bounds, padding, true);
    }
    unselectPOI(): void {
        this.indoorMap.unselectFeature();
    }
    turnOffNavigation(): void {
        this.indoorMap.setNavigationMode(false);
    }
    getDirections() : void {
        return this.indoorMap.getRenderer()._directionsRenderer.directions;
    }
}
